package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
@Serializable
data class WalmartVerifyOTPWithSetupCodeResponse(
    val status: String? = null,
    val description: String? = null
)